import React,{useCallback,useEffect,useRef} from 'react';
import {patchLevels,PatchLevel} from '../services/patchLevels';
import UnearnedPatchSettings from './UnearnedPatchSettings';

export default function HiddenPatchSettings({farmId,onDirtyChange,kind='unearned'}:{farmId:string;onDirtyChange:(dirty:boolean)=>void;kind?:'unearned'|'back'}){
 const dirtyLevels=useRef(new Set<PatchLevel>());
 const report=useCallback((level:PatchLevel,dirty:boolean)=>{
  if(dirty)dirtyLevels.current.add(level);else dirtyLevels.current.delete(level);
  onDirtyChange(dirtyLevels.current.size>0);
 },[onDirtyChange]);
 const callbacks=React.useMemo(()=>Object.fromEntries(patchLevels.map(level=>[level,(dirty:boolean)=>report(level,dirty)])) as Record<PatchLevel,(dirty:boolean)=>void>,[report]);
 useEffect(()=>()=>{dirtyLevels.current.clear();onDirtyChange(false);},[farmId,onDirtyChange]);
 return <details className="border rounded-2xl p-5 bg-white"><summary className="font-medium cursor-pointer">{kind==='back'?'Patch back artwork':'Hidden patch artwork'}</summary>
  <p className="text-sm text-gray-600 mt-4">{kind==='back'?'One backing image for each rarity, shown behind the name and stats when turned over.':'One hidden image for each rarity. Names and individual artwork stay hidden until earned.'}</p>
  <div className="space-y-3 mt-4">{patchLevels.map(level=><UnearnedPatchSettings key={level} kind={kind} level={level} farmId={farmId} onDirtyChange={callbacks[level]}/>)}</div>
 </details>;
}
